<template>
  <div class="feedback-modal" v-if="visible">
    <div class="feedback-overlay" @click="closeModal"></div>
    <div class="feedback-content">
      <div class="feedback-success" v-if="showSuccess">    
        Awesome! Thanks for your feedback!
      </div>
  <template v-else>
      <!-- 帮助性评价 -->
      <div class="helpful-section" v-if="!showFeedbackForm">
        <h3 class="feedback-title">Was this information helpful?</h3>
        <div class="feedback-buttons">
          <button 
            class="feedback-btn feedback-btn-like" 
            @click="handleHelpful(true)"
            :class="{ active: helpful === true }"
          >
        
           <img src="@/assets/images/icon-like.png" alt="like" width="16" height="16"></img>
      
            <span>Yes</span>
          </button>
          <button 
            class="feedback-btn feedback-btn-dislike" 
            @click="handleHelpful(false)"
            :class="{ active: helpful === false }"
          >
       
          <img src="@/assets/images/icon-like.png" alt="like" width="16" height="16" style="transform: rotate(180deg) !important; "></img>
            <span>No</span>
          </button>
        </div>
      </div>

      <!-- 反馈原因表单 -->
      <div class="feedback-form" v-if="showFeedbackForm">
        <h3 class="feedback-title">Sorry we couldn’t resolve your issue. To better assist you, please select a issue type so we can provide more accurate help.</h3>
        <div class="feedback-options">
          <label 
            v-for="option in feedbackOptions" 
            :key="option.value"
            class="feedback-option"
          >
            <input 
              type="checkbox" 
              :value="option.value"
              v-model="selectedReasons"
              @change="handleReasonChange"
            />
            <span class="checkbox-custom"></span>
            <span class="option-text">{{ option.label }}</span>
          </label>
        </div>
        
        <!-- 其他原因输入框 -->
        <div class="other-reason" v-if="showOtherInput">
          <textarea 
            v-model="otherReason"
            placeholder=""
            class="feedback-textarea"
            rows="4"
          ></textarea>
        </div>
        
        <div class="feedback-actions">
          <button 
            class="submit-btn" 
            @click="submitFeedback"
            :disabled="!canSubmit"
          >
          Submit
          </button>
        </div>
      </div>
    </template>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FeedbackModal',
  props: {
    visible: {
      type: Boolean,
      default: true
    },
    articleId: {
      type: String,
      default: ''
    },
    articleTitle: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      showSuccess: false,
      helpful: null, // true: 有帮助, false: 没帮助, null: 未选择
      showFeedbackForm: false,
      selectedReasons: [],
      otherReason: '',
      feedbackOptions: [
        { value: 'no_info', label: 'Cannot find the required information I needed' },
        { value: 'hard_understand', label: 'Too technical' },
        { value: 'too_many_steps', label: 'Too many steps' },
        { value: 'translation_issue', label: "Doesn't match the actual page" },
        { value: 'other', label: 'Other   Please share more details (e.g., the information you need)' }
      ]
    }
  },
  watch: {
    articleId(newVal) {
      if (newVal) {
        this.showFeedbackForm = false;
        this.selectedReasons = [];
        this.otherReason = '';
        this.showSuccess = false;
      }
    }
  },
  computed: {
    showOtherInput() {
      return this.selectedReasons.includes('other')
    },
    canSubmit() {
      if (this.selectedReasons.length === 0) return false
      if (this.selectedReasons.includes('other') && !this.otherReason.trim()) return false
      return true
    }
  },
  methods: {
    closeModal() {
      this.$emit('close')
    },
    
    handleHelpful(isHelpful) {
      this.helpful = isHelpful
      
      if (isHelpful) {
        // 如果用户觉得有帮助，直接提交并关闭
        this.submitHelpfulFeedback()
      } else {
        // 如果用户觉得没帮助，显示反馈表单
        this.showFeedbackForm = true
        // 滚动到表单位置
        this.$nextTick(() => {
          // 延迟一点时间确保表单完全渲染
          setTimeout(() => {
            this.scrollToForm()
          }, 100)
        })
      }
    },
    
    handleReasonChange() {
      // 处理原因选择变化
      console.log('选择的反馈原因:', this.selectedReasons)
    },
    
    // 滚动到表单位置
    scrollToForm() {
      const formElement = this.$el.querySelector('.feedback-form')
      const modalElement = this.$el.querySelector('.feedback-content')
      
      if (formElement && modalElement) {
        // 计算需要滚动的距离
        const formTop = formElement.offsetTop
        const modalTop = modalElement.scrollTop
        const modalHeight = modalElement.clientHeight
        
        // 确保表单完全可见
        modalElement.scrollTo({
          top: Math.max(0, formTop - 20), // 留20px的顶部间距
          behavior: 'smooth'
        })
        
        console.log('已滚动到反馈表单位置')
      }
    },
    
    submitHelpfulFeedback() {
      this.zhugePoint("macc-help-文章评论", {
        userid: this.GLOBAL.userid, //用户id
        helpful: true,
        articleId: this.articleId,
        articleTitle: this.articleTitle,
        timestamp: new Date().toISOString()
      })
     
      
    this.showSuccess = true;
    },
    
    submitFeedback() {
      if (!this.canSubmit) return
      
      const feedbackData = {
        type: 'unhelpful',
        helpful: false,
        reasons: this.selectedReasons,
        otherReason: this.otherReason,
        articleId: this.articleId,
        articleTitle: this.articleTitle,
        timestamp: new Date().toISOString()
      }
      this.zhugePoint("macc-help-文章评论", {
        userid: this.GLOBAL.userid, //用户id
        reasons: this.selectedReasons,
        otherReason: this.otherReason,
        articleId: this.articleId,
        articleTitle: this.articleTitle
      });
      this.showSuccess = true;
      this.showFeedbackForm = false;
    //  this.$emit('submit', feedbackData)
      this.closeModal()
    },
    
    resetForm() {
      this.helpful = null
      this.showFeedbackForm = false
      this.selectedReasons = []
      this.otherReason = ''
    }
  },
  
  watch: {
    visible(newVal) {
      if (!newVal) {
        this.resetForm()
      }
    }
  }
}
</script>

<style scoped>
.feedback-modal{
padding: 16px;
text-align: left;
}

.feedback-content {
  position: relative;
  background: rgba(1, 27, 70, 0.04);
  border-radius: 8px;
  padding: 16px;
  width: 100%;
  max-height: 80vh;
  overflow-y: auto;
}

.feedback-title {
  color: #30343D;
  margin: 0 0 16px 0;
  font-weight: 400;
}

/* 帮助性评价按钮 */
.feedback-buttons {
  display: flex;
  gap: 16px;
}

.feedback-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 24px;
  border: 1px solid rgba(1, 27, 70, 0.16);
  border-radius: 6px;
  background: white;
  color: #30343D;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 14px;
}

.feedback-btn:hover {
  border-color: #1890ff;
  color: #1890ff;
}

.feedback-btn.active {
  border-color: #1890ff;
  background: #1890ff;
  color: white;
}

.feedback-btn i {
  font-size: 16px;
}

/* 图片 hover 效果 */
.feedback-btn img {
  transition: all 0.2s ease;
  opacity: 0.7;
}

.feedback-btn:hover img {
  opacity: 1;
  filter: brightness(0) saturate(100%) invert(48%) sepia(79%) saturate(2476%) hue-rotate(202deg) brightness(118%) contrast(119%);
}

.feedback-btn.active img {
  opacity: 1;
  filter: brightness(0) saturate(100%) invert(100%) sepia(0%) saturate(0%) hue-rotate(93deg) brightness(103%) contrast(103%);
}

/* 第二个按钮（否）的图标旋转180度 */
.feedback-btn-dislike img {
  transform: rotate(180deg);
}

/* 反馈选项 */
.feedback-options {
  margin-bottom: 20px;
}

.feedback-option {
  display: flex;
  padding: 12px 0;
  cursor: pointer;
  transition: background-color 0.2s ease;
  border-radius: 4px;
  padding-left: 8px;
}

.feedback-option:hover {
  background-color: #f5f5f5;
}

.feedback-option input[type="checkbox"] {
  display: none;
}

.checkbox-custom {
  width: 18px;
  height: 18px;
  border: 2px solid #d0d0d0;
  border-radius: 3px;
  margin-right: 12px;
  position: relative;
  transition: all 0.2s ease;
}

.feedback-option input[type="checkbox"]:checked + .checkbox-custom {
  background: #1B6DFA;
  border-color: #1B6DFA;
}

.feedback-option input[type="checkbox"]:checked + .checkbox-custom::after {
  content: '✓';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: white;
  font-size: 12px;
  font-weight: bold;
}

.option-text {
  font-size: 14px;
  color: #333;
  flex: 1;
}

/* 其他原因输入框 */
.other-reason {
  margin-bottom: 20px;
}

.feedback-textarea {
  width: 100%;
  padding: 12px;
  border: 1px solid #d0d0d0;
  border-radius: 4px;
  font-size: 14px;
  resize: vertical;
  min-height: 80px;
  font-family: inherit;
}

.feedback-textarea:focus {
  outline: none;
  border-color: #1890ff;
}

.feedback-textarea::placeholder {
  color: #999;
}

/* 提交按钮 */
.feedback-actions {

}

.submit-btn {
  padding: 6px 28px;
  background: #1B6DFA;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.submit-btn:hover:not(:disabled) {
  background: #40a9ff;
}

.submit-btn:disabled {
  background: rgba(1, 27, 70, 0.04);
  color: rgba(1, 27, 70, 0.16);
  cursor: not-allowed;
  border: 1px solid rgba(1, 27, 70, 0.16)
}

/* 禁用图片放大功能 */
.feedback-modal img {
  pointer-events: none;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}

.feedback-modal img:hover {
  transform: none !important;
  scale: none !important;
  zoom: none !important;
}

/* 禁用所有图片相关的放大效果 */
.feedback-modal * {
  transform: none !important;
  transition: none !important;
}

.feedback-modal img,
.feedback-modal img:hover,
.feedback-modal img:focus,
.feedback-modal img:active {
  transform: none !important;
  scale: none !important;
  zoom: none !important;
  transition: none !important;
  pointer-events: none !important;
}

</style>
